export const MAINTENANCE_CATEGORY = "Maintenance Fee";

export const STICKER_REQUIRES_MAINTENANCE_MESSAGE =
  "Sticker fee cannot be paid until at least one Maintenance Fee payment has been recorded for this house. Please pay the Maintenance Fee first.";

export function isStickerCategory(category) {
  return String(category || "").startsWith("Sticker fee");
}

export function hasRecordedMaintenanceFee(payments) {
  return (payments || []).some(
    (p) => (p.category || MAINTENANCE_CATEGORY) === MAINTENANCE_CATEGORY && p.status === "approved"
  );
}

export function stickerPaymentBlockedReason(category, hasMaintenance) {
  if (!isStickerCategory(category) || hasMaintenance) return null;
  return STICKER_REQUIRES_MAINTENANCE_MESSAGE;
}
